import { render, staticRenderFns } from "./createCorpSalesExcellence.vue?vue&type=template&id=32fcc7f5&"
import script from "./createCorpSalesExcellence.vue?vue&type=script&lang=js&"
export * from "./createCorpSalesExcellence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports